"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numPad = numPad;
exports.replaceAll = replaceAll;
exports.nominate = nominate;
exports.denominate = denominate;
exports.unpackCallerId = unpackCallerId;
exports.decodeProtocolMessage = decodeProtocolMessage;
exports.encodeProtocolMessage = encodeProtocolMessage;
exports.waterlineWhereMerge = waterlineWhereMerge;
exports.KEY = exports.CAST = exports.FORMAT = exports.ESCAPES = void 0;

var _shortid = _interopRequireDefault(require("shortid"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _isSymbol = _interopRequireDefault(require("lodash/isSymbol"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));

var _differenceInSeconds = _interopRequireDefault(require("date-fns/differenceInSeconds"));

var _differenceInMinutes = _interopRequireDefault(require("date-fns/differenceInMinutes"));

var _differenceInHours = _interopRequireDefault(require("date-fns/differenceInHours"));

var _zonedTimeToUtc = _interopRequireDefault(require("date-fns-tz/zonedTimeToUtc"));

var _errors = _interopRequireDefault(require("./errors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file misc.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Wednesday, 14th August 2019 4:20:55 pm
 * @copyright 2015 - 2019 SKAT LLC, Delive LLC
 * 
 */
const CAST = {
  'String': value => (0, _isNil.default)(value) ? '' : (0, _isSymbol.default)(value) ? 'SYM:' + (0, _shortid.default)() : String(value),
  'Number': value => (0, _isNil.default)(value) ? 0 : isNaN(value) ? 0 : (0, _isSymbol.default)(value) ? 0 : Number(value),
  Integer: value => {
    value = parseInt(CAST.Number(value), 10);
    if (value === NaN) throw (0, _errors.default)('E_UUNA-D', 'UNABLE_TO_CAST_VALUE_TO_INTEGER');
    return value;
  },
  asTimezone: (value, timezoneName) => (0, _zonedTimeToUtc.default)((0, _isString.default)(value) ? (0, _parseISO.default)(value) : value, timezoneName) // for example '15:00' becomes Date(15:00+04:00)

};
exports.CAST = CAST;

function parseDate(date) {
  if (!date) return null;
  return typeof date === 'string' ? (0, _parseISO.default)(date) : date;
}

const FORMAT = {
  'String': value => CAST.String(value),
  'Money': value => (0, _isNil.default)(value) ? '0' : isNaN(value) ? '0' : String(Number(value).toFixed(2)),
  'Uppercase': value => CAST.String(value).toUpperCase(),
  'Lowercase': value => CAST.String(value).toLowerCase(),
  'Duration': (startDate, endDate) => {
    let now = parseDate(endDate) || new Date();
    let start = parseDate(startDate);
    let minus = '';
    if (!start) return '--:--';

    if (now < start) {
      const t = now;
      now = start;
      start = t;
      minus = '- ';
    }

    let value = [(0, _differenceInMinutes.default)(now, start) % 60, (0, _differenceInSeconds.default)(now, start) % 60];
    const hours = (0, _differenceInHours.default)(now, start);
    if (hours) value = [hours, ...value];
    value = value.map(v => isNaN(v) ? '--' : v).map(v => numPad(String(v), 2));
    return minus + value.join(':');
  },
  'Number': value => String(CAST.Number(value))
};
exports.FORMAT = FORMAT;

/**
 * Adds leading zero's to an initial number
 * @function numPad
 * @param {*} number
 * @param {*} size
 */
function numPad(number, size) {
  if (isNaN(number)) return String(number);
  let s = String(number);

  while (s.length < (size || 2)) s = '0' + s;

  return s;
}
/**
 * @function replaceAll
 * @param {*} text
 * @param {*} pattern
 * @param {*} replacement
 */


function replaceAll(text, pattern, replacement) {
  return text.split(pattern).join(replacement);
}

const ESCAPES = [[';', '\\u003B'], ['*', '\\u002A'], ['\n', '\\u000A'], ['\r', '\\u000D']];
/**
 * @constant KEY
 */

exports.ESCAPES = ESCAPES;
const KEY = {
  UP: 38,
  DOWN: 40,
  ENTER: 13,
  TAB: 9,
  ESCAPE: 27,
  BACKSPACE: 8
};
exports.KEY = KEY;

function nominate(value, denominator) {
  const _value = CAST.Number(value);

  const _denominator = CAST.Number(denominator);

  return CAST.Integer(_value * _denominator);
}

function denominate(value, denominator) {
  const _value = CAST.Integer(value);

  const _denominator = CAST.Integer(denominator);

  return _value / _denominator;
}
/**
 * Unpacks callerId string prepared by server to an object literal
 * @param {string} meta 
 */


function unpackCallerId(meta) {
  const SEPARATOR = '\u00A0';

  if (meta.includes(SEPARATOR)) {
    const [clientId, clientName, orderId, operatorId, queueName, callId, callerId, serviceId, clientPriority, autoId, bindedOrders] = meta.split(SEPARATOR);
    return {
      id: CAST.Number(callId),
      clientId: CAST.Number(clientId),
      clientName: CAST.String(clientName),
      clientPhone: CAST.String(callerId),
      orderId: CAST.Number(orderId),
      operatorId: CAST.Number(operatorId),
      queueName: CAST.String(queueName),
      serviceId: CAST.Number(serviceId),
      clientPriority: CAST.Number(clientPriority),
      autoId: CAST.Number(autoId),
      bindedOrders: bindedOrders.split('|').map(id => CAST.Number(id))
    };
  } else throw (0, _errors.default)('E_MMIS-B', 'MISCONFIGURED_SIP_SERVER');
}
/**
* Removes escaping from special characters in a string
* @param {String} sourceString escaped string
* @method skat.connections.Protocol#decode
* @return {String} line
*/


function decodeProtocolMessage(message) {
  if (!message) return message;
  ESCAPES.forEach(([to, from]) => message = replaceAll(message, from, to));
  return message;
}
/**
* Escapes unsafe characters for a protocol.
* @param {String} sourceString unshielded string
* @method skat.connections.Protocol#encode
* @return {String} escaped string
*/


function encodeProtocolMessage(message) {
  if (!message) return message;
  ESCAPES.forEach(([from, to]) => message = replaceAll(message, from, to));
  return message;
}

function waterlineWhereMerge(whereA, whereB) {
  function group(where) {
    const result = [];

    for (const key in where) result.push({
      [key]: where[key]
    });

    return result;
  }

  if (!whereA.and && !whereB.and) {
    const aKeys = Object.keys(whereA);
    const bKeys = Object.keys(whereB);
    const hasDuplicateKeys = aKeys.some(k => bKeys.includes(k));
    if (hasDuplicateKeys) return {
      and: [...group(whereA), ...group(whereB)] //$FlowFixMe

    };else return { ...whereA,
      ...whereB
    };
  }

  if (whereA.and && whereB.and) return {
    and: [...whereA.and, ...whereB.and]
  };

  if (whereA.and && !whereB.and) {
    const andB = group(whereB); //$FlowFixMe

    return {
      and: [...whereA.and, ...andB]
    };
  }

  if (!whereA.and && whereB.and) {
    const andA = group(whereA); //$FlowFixMe

    return {
      and: [...andA, ...whereB.and]
    };
  }

  return {};
}